//Poems.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getMethod } from '../services/apiService';
import { IMG_URL } from '../utility/config';
import Poemcard from '../components/Poems/Poemcard';
import LoadingSpinner from '../utility/LoadingSpinner';

function Poem() {
  const [poemData, setPoemData] = useState([]);
  const [loading, setLoading] = useState(true);
  const IMG_BASE_URL = IMG_URL
  useEffect(() => {
    fetchData();
  }, []);
  const navigate = useNavigate();
  //Display poems
  const fetchData = async () => {
    try {
      const response = await getMethod('poems');
      console.log("response======", response)
      if (response && response.status && response.data && Array.isArray(response.data.data)) {
        setPoemData(response.data.data);
      } else {
        console.error("Invalid response format:", response);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleClick = () => {
    navigate(`/`);  // Navigate with query param & path, query, key=value pair
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="poems1" >
      <h2 className="poems__title_photo"><span><a href="#" onClick={(e) => handleClick()}><img src={require('../assets/images/back.png')} style={{ width: 25 }} /></a></span>Poems</h2>
      <div className="" >
        <div className="poem-list">
          {Array.isArray(poemData) &&
            poemData
              .filter(item => item.image_url && item.title && item.id && item.description)
              .map(item => (
                <div key={item.id}>
                  <Poemcard
                    className="poem-list__item"
                    image_url={`${IMG_BASE_URL}/${item.image_url}`}
                    title={item.title}
                    id={item.id}
                    description={item.description}
                    price={item.price}
                  />
                </div>
              ))}


        </div>
      </div>
    </div>
  );

}

export default Poem;